import { answerContentSchema } from "@/schema/console/evaluation-reports/AnswerContent";
import { z } from "zod";

export const sdgTargetResultSchema = z.object({
  id: z.number(),
  target_number: z.number(),
  description: z.string(),
  score: z.number().nullable(),
  evaluation_note: z.string().nullable(),
  answer_contents: z.array(answerContentSchema),
});

export type SdgTargetResult = z.infer<typeof sdgTargetResultSchema>;
